import reduce from 'lodash/reduce';

const objectUtils = {
    reverseMap: (map) => {
        const reversed = {};
        for (const key in map) {
            if (map.hasOwnProperty(key)) {
                const value = map[key];
                reversed[value] = key;
            }
        }

        return reversed;
    },
    removeFalsyVals: (obj) => {
        const definedVals = reduce(obj, (result, value, key) => {
            if (value) {
                result[key] = value;
            }
            return result;
        }, {});
        return definedVals;
    },
};

export {
    objectUtils,
};

export default objectUtils;
